import { fromBech32 } from "@cosmjs/encoding";
import { fromBech32 as btcFromBech32 } from "bitcoinjs-lib/src/address";
import { Network } from "rujira.js";

export const walletType = (
  address: string
): "evm" | "cosmos" | "xrp" | "tron" | ["utxo", Network] => {
  if (address.startsWith("0x")) return "evm";
  if (address.startsWith("bc1")) return ["utxo", "BTC"];
  if (address.startsWith("bitcoincash")) return ["utxo", "BCH"];
  if (address.startsWith("q")) return ["utxo", "BCH"];
  if (address.startsWith("p")) return ["utxo", "BCH"];
  if (address.startsWith("D")) return ["utxo", "DOGE"];
  if (address.startsWith("L")) return ["utxo", "LTC"];
  if (address.startsWith("ltc") && btcFromBech32(address).prefix === "ltc")
    return ["utxo", "LTC"];
  if (address.startsWith("r")) return "xrp";
  if (address.startsWith("X")) return "xrp";
  if (address.startsWith("T")) return "tron";
  fromBech32(address);
  return "cosmos";
};
